module.exports = __webpack_public_path__ + "media/InsertionSort_slow.eaa03129.mp4";